import COLORS from '@/constants/colors';
import { Box, Collapse } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { SideNavigationOptionUi } from './SideNavigationOptionsUi';
import { useSideNavigationOptionsViewController } from './SideNavigationOptionsViewController';

export function SideNavigationOptions() {
  const { uiState, actions } = useSideNavigationOptionsViewController();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {uiState.map((sideNavOption) => (
        <SideNavigationOption
          key={`nav-${sideNavOption.id}`}
          option={sideNavOption}
          isRoot
        />
      ))}
    </Box>
  );
}

function SideNavigationOption(props: {
  option: SideNavigationOptionUi;
  isRoot?: boolean;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        ml: props.isRoot ? '0px' : '8px',
      }}
    >
      <NavLink
        to={props.option.to}
        style={({ isActive }) => ({
          fontWeight: isActive ? 'bold' : 600,
          fontSize: '12px',
          backgroundColor: isActive ? COLORS.gray_8 : undefined,
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
          color: COLORS.mercanto_blue,
          padding: '9px 8px',
          textDecoration: 'none',
          borderRadius: '6px',
        })}
      >
        {props.option.icon}
        {props.option.label}
      </NavLink>
      {!!props.option.children.length && (
        <Collapse in={props.option.expanded}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              pt: '8px',
            }}
          >
            {props.option.children.map((child) => (
              <SideNavigationOption
                key={`nav-child-${child.id}`}
                option={child}
              />
            ))}
          </Box>
        </Collapse>
      )}
    </Box>
  );
}
